module.exports = "{{text}}\n<span class=\"svg-icons-wrp svg-icons-wrp_multiselect\">\n        <svg class=\"svg-icons svg-icons_multiselect\"><use xlink:href=\"#icon-checked\" /> </svg>\n    </span>";


//////////////////
// WEBPACK FOOTER
// ../src/form/editors/impl/multiSelect/templates/multiSelectItem.hbs
// module id = 671
// module chunks = 0